import wowzaChildren from './wowza';
import transcribeChildren from './transcribe';
import ldapChildren from './ldap';
import ssoChildren from './sso';
import calendarChildren from './calendar';
import ServerIcon from '../../../../images/server.svg?component';
import ROUTE_NAMES from '../../routeNames';
import SECTION_NAMES from '../../sectionNames';
import { usePermissionsStore } from '@/vue/stores/permissions';

const meta = {
    title: SECTION_NAMES.SERVERS_AND_SERVICES,
    icon: ServerIcon,
};

const EntitiesList = (): Promise<unknown> => import('../../../components/EntitiesList.vue');

export default [
    {
        path: 'wowza',
        name: ROUTE_NAMES.ADMIN_MEDIA_SERVER,
        component: EntitiesList,
        redirect: { name: ROUTE_NAMES.ADMIN_MEDIA_SERVER_LIST },
        meta: {
            ...meta,
            permissions: (): string[] => [usePermissionsStore().allPermissions.adminServersWowza],
        },
        children: wowzaChildren,
    },
    {
        path: 'transcription-service',
        name: ROUTE_NAMES.ADMIN_TRANSCRIPTION_SERVICE,
        component: EntitiesList,
        redirect: { name: ROUTE_NAMES.ADMIN_TRANSCRIPTION_SERVICE_LIST },
        meta: {
            ...meta,
            permissions: (): string[] => [
                usePermissionsStore().allPermissions.adminServersTranscriptionService,
            ],
        },
        children: transcribeChildren,
    },
    {
        path: 'ldap-servers',
        name: ROUTE_NAMES.ADMIN_LDAP_SERVER,
        component: EntitiesList,
        redirect: { name: ROUTE_NAMES.ADMIN_LDAP_SERVER_LIST },
        meta: {
            ...meta,
            permissions: (): string[] => [
                usePermissionsStore().allPermissions.adminServersLdapServers,
            ],
        },
        children: ldapChildren,
    },
    {
        path: 'sso-configs',
        name: ROUTE_NAMES.ADMIN_SSO_CONFIG,
        component: EntitiesList,
        redirect: { name: ROUTE_NAMES.ADMIN_SSO_CONFIG_LIST },
        meta: {
            ...meta,
            permissions: () => [usePermissionsStore().allPermissions.adminServersSsoConfigs],
        },
        children: ssoChildren,
    },
    {
        path: 'calendar-configs',
        name: ROUTE_NAMES.ADMIN_CALENDAR_CONFIG,
        component: EntitiesList,
        redirect: { name: ROUTE_NAMES.ADMIN_CALENDAR_CONFIG_LIST },
        meta: {
            ...meta,
            permissions: () => [usePermissionsStore().allPermissions.adminServersCalendarConfigs],
        },
        children: calendarChildren,
    },
];
